import { SignIn as ClerkSignIn } from '@clerk/clerk-react';

export function SignIn() {
  return (
    <div className="auth-container">
      <div className="onboarding-logo">
        <div className="onboarding-logo-text">CLAWZEMPIC</div>
        <div className="onboarding-logo-sub">The Inference Diet</div>
      </div>
      <ClerkSignIn
        routing="hash"
        afterSignInUrl="/auth-callback"
        signUpUrl="/sign-up"
      />
    </div>
  );
}
